import { useQuery } from "@apollo/client";
import React from "react";
import { GetTenantDocument } from "../../../gql/graphql";

/**
 * This component shows or hides its children if a tenant has certain role
 * @param param0
 * @returns
 */
const NBPlanAccessControlComponent = ({
  children,
  plans,
  hiddenChildren
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GetTenantDocument);
  if (plans.some(plan => plan === data?.getTenant.plan)) return /*#__PURE__*/React.createElement(React.Fragment, null, children);else return hiddenChildren ? /*#__PURE__*/React.createElement(React.Fragment, null, hiddenChildren) : null;
};
export { NBPlanAccessControlComponent };